import { getBffUrl as bffUrlSelector } from 'selectors'
import store from '../store'

import * as Api from '../utils/api'

const getBffUrl = () => bffUrlSelector(store.getState())

export const registerUser = body => Api.post(
  `${getBffUrl()}/users/register`,
  body
)

export const fetchConfig = timezone => Api.post(
  `${getBffUrl()}/config?timezone=${encodeURIComponent(timezone)}`
)

export const updateConfig = (body, newsradarId) => Api.patch(
  `${getBffUrl()}/groot_configs/${newsradarId}`,
  body
)

export const updateUserConfig = body => Api.post(
  `${getBffUrl()}/groot_user_configs`,
  body
)

export const fetchPromptHistory = (key, limit = 10) => Api.get(
  `${getBffUrl()}/prompt_history?key=${encodeURIComponent(key)}&limit=${limit}`
)

export const fetchDemos = languageId => Api.get(
  `${getBffUrl()}/demos?language_id=${encodeURIComponent(languageId)}`
)

export const createPersona = body => Api.post(
  `${getBffUrl()}/personas`,
  body
)

export const updatePersona = (id, body) => Api.patch(
  `${getBffUrl()}/personas/${id}`,
  body
)

export const generatePersonas = () => Api.post(
  `${getBffUrl()}/personas/generate`,
  {}
)

export const createPromptHistoryEntry = (key, prompt) => Api.post(
  `${getBffUrl()}/prompt_history`,
  { key, prompt }
)

export const deletePromptHistoryEntry = id => Api.destroy(
  `${getBffUrl()}/prompt_history/${id}`
)

export const clearPromptHistory = key => Api.destroy(
  `${getBffUrl()}/prompt_history/clear`,
  { key }
)

export const fetchContentDeskConfig = () => Api.get(
  `${getBffUrl()}/groot_ccd_configs`
)

export const updateContentDeskConfig = (id, body) => Api.patch(
  `${getBffUrl()}/groot_ccd_configs/${id}`,
  body
)

export const searchAllowedDomains = body => Api.post(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/search`,
  body
)

export const createAllowedDomain = body => Api.post(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed`,
  body
)

export const updateAllowedDomainSenderDomains = (id, body) => Api.patch(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/${id}/sender_domains`,
  body
)

export const updateAllowedDomainOpenTracking = (id, body) => Api.patch(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/${id}/tracking/open`,
  body
)

export const updateAllowedDomainClickTracking = (id, body) => Api.patch(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/${id}/tracking/click`,
  body
)

export const updateAllowedDomainTrackingProtocol = (id, body) => Api.patch(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/${id}/tracking/protocol`,
  body
)

export const deleteAllowedDomain = id => Api.destroy(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/${id}`
)

export const refreshStatusAllowedDomain = body => Api.post(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/status/refresh`,
  body
)

export const fetchAllowedDomainStatus = body => Api.post(
  `${getBffUrl()}/groot_ccd_configs/domain/allowed/status`,
  body
)

export const startExport = body => Api.post(
  `${getBffUrl()}/export`,
  body
)

export const checkExportJobStatus = traceId => Api.get(
  `${getBffUrl()}/export/check_job_status?trace_id=${traceId}`
)

export const logout = body => Api.post(
  `${getBffUrl()}/logout`,
  body
)

export const login = body => Api.post(
  `${getBffUrl()}/login`,
  body
)

export const search = body => Api.post(
  `${getBffUrl()}/search`,
  body
)

export const searchByIds = body => Api.post(
  `${getBffUrl()}/search/by_ids`,
  body
)

export const validate = body => Api.post(
  `${getBffUrl()}/search/validate`,
  body
)

export const fetchNewsIds = body => Api.post(
  `${getBffUrl()}/search/news_ids`,
  body
)

export const searchInfluencers = body => Api.post(
  `${getBffUrl()}/search/influencers`,
  body
)

export const searchInfluencersXlsx = body => Api.post(
  `${getBffUrl()}/search/influencers/xlsx`,
  body,
  'blob'
)

export const searchPublications = body => Api.post(
  `${getBffUrl()}/search/publications`,
  body
)

export const searchPublicationsXlsx = body => Api.post(
  `${getBffUrl()}/search/publications/xlsx`,
  body,
  'blob'
)

export const searchPageIdentities = body => Api.post(
  `${getBffUrl()}/search/page_identities`,
  body
)

export const searchAllPublications = body => Api.post(
  `${getBffUrl()}/publications/search`,
  body
)

export const searchPageIdentityPosts = body => Api.post(
  `${getBffUrl()}/search/page_identities/posts`,
  body
)

export const searchAiAnalysis = body => Api.post(
  `${getBffUrl()}/search/ai_analysis`,
  body
)

export const getMediaReview = mediaReviewId => Api.get(
  `${getBffUrl()}/media_reviews/${mediaReviewId}`
)

export const reorderMediaReview = body => Api.post(
  `${getBffUrl()}/media_reviews/reorder`,
  body
)

export const removeNewsFromMediaReview = body => Api.post(
  `${getBffUrl()}/media_reviews/remove_news`,
  body
)

export const loadFullText = id => Api.get(
  `${getBffUrl()}/media_reviews/full_text/${id}`
)

export const loadNewsFullText = id => Api.get(
  `${getBffUrl()}/news/${id}/full_text`
)

export const filterMediaReviews = body => Api.post(
  `${getBffUrl()}/media_reviews/filter`,
  body
)

export const getMediaReviewSnapshot = id => Api.get(
  `${getBffUrl()}/media_reviews/${id}/snapshot`
)

export const getNews = id => Api.get(
  `${getBffUrl()}/news/${id}`
)

export const getNewsAiAnalysis = body => Api.post(
  `${getBffUrl()}/news/ai_analysis`,
  body
)

export const createPublication = body => Api.post(
  `${getBffUrl()}/publications`,
  body
)

export const submitShopping = (id, type) => Api.get(
  `${getBffUrl()}/submit_shopping/${id}/?type=${type}`
)

export const sendMail = body => Api.post(
  `${getBffUrl()}/send_mail`,
  body
)

export const createDispatch = body => Api.post(
  `${getBffUrl()}/dispatches`,
  body
)

export const cancelDispatch = id => Api.post(
  `${getBffUrl()}/dispatches/${id}/cancel`
)

export const fetchDispatchLog = () => Api.get(
  `${getBffUrl()}/dispatches/log`
)

export const saveSubscriptions = body => Api.post(
  `${getBffUrl()}/subscriptions`,
  body
)

export const updateUser = (body, userId) => Api.patch(
  `${getBffUrl()}/users/${userId}`,
  body
)

export const forgotPassword = body => Api.post(
  `${getBffUrl()}/users/forgot_password`,
  body
)

export const resetPassword = body => Api.post(
  `${getBffUrl()}/users/reset_password`,
  body
)

export const activateUser = body => Api.post(
  `${getBffUrl()}/users/activate`,
  body
)

export const createCustomTag = body => Api.post(
  `${getBffUrl()}/custom_tags`,
  body
)

export const updateCustomTag = (id, body) => Api.patch(
  `${getBffUrl()}/custom_tags/${id}`,
  body
)

export const deleteCustomTag = (id, body) => Api.post(
  `${getBffUrl()}/custom_tags/${id}`,
  body
)

export const emptyCustomTag = body => Api.post(
  `${getBffUrl()}/empty_custom_tag`,
  body
)

export const fetchNewsForCustomTag = (id, body) => Api.post(
  `${getBffUrl()}/custom_tags/${id}/news`,
  body
)

export const assignCustomTagToNews = body => Api.post(
  `${getBffUrl()}/assign_custom_tag`,
  body
)

export const suggestCustomTags = body => Api.post(
  `${getBffUrl()}/custom_tag_suggestions`,
  body
)

export const createCustomTagGroup = body => Api.post(
  `${getBffUrl()}/custom_tag_groups`,
  body
)

export const updateCustomTagGroup = (id, body) => Api.patch(
  `${getBffUrl()}/custom_tag_groups/${id}`,
  body
)

export const deleteCustomTagGroup = id => Api.destroy(
  `${getBffUrl()}/custom_tag_groups/${id}`
)

export const assignCustomTagToGroup = (groupId, customTagId) => Api.post(
  `${getBffUrl()}/custom_tag_groups/${groupId}/custom_tags/${customTagId}`
)

export const removeCustomTagFromGroup = (groupId, customTagId) => Api.destroy(
  `${getBffUrl()}/custom_tag_groups/${groupId}/custom_tags/${customTagId}`
)

export const uploadFile = data => {
  const formData = new FormData()
  data.forEach(({ key, value, filename }) => {
    if (filename) {
      formData.append(key, value, filename)
    } else {
      formData.append(key, value)
    }
  })

  return Api.form(
    `${getBffUrl()}/upload_file`,
    formData
  )
}

export const generateDashboardThumbnail = (id, body) => Api.post(
  `${getBffUrl()}/dashboards/${id}/thumbnail`,
  body
)

export const updateCharts = body => Api.post(
  `${getBffUrl()}/charts`,
  body
)

export const exportExcel = body => Api.post(
  `${getBffUrl()}/charts/excel`,
  body,
  'blob'
)

export const previewAlertChart = body => Api.post(
  `${getBffUrl()}/charts/visual_viper_render`,
  body,
  'blob'
)

export const exportPowerpoint = body => Api.post(
  `${getBffUrl()}/charts/powerpoint`,
  body,
  'blob'
)

export const exportPowerpointBatch = body => Api.post(
  `${getBffUrl()}/charts/powerpoint_batch`,
  body,
  'blob'
)

export const aiChartAnalysis = body => Api.post(
  `${getBffUrl()}/charts/ai_analysis`,
  body
)

export const chartsAutoSelectionNewsFeedAiAnalysis = body => Api.post(
  `${getBffUrl()}/charts/auto_selection_news_feed_ai_analysis`,
  body
)

export const aiChartDescription = body => Api.post(
  `${getBffUrl()}/charts/ai_description`,
  body
)

export const updateNews = (id, body) => Api.patch(
  `${getBffUrl()}/news/${id}`,
  body
)

export const summarizeNews = body => Api.post(
  `${getBffUrl()}/news/summarize`,
  body
)

export const improveSummaryPrompt = body => Api.post(
  `${getBffUrl()}/news/improve_summary_prompt`,
  body
)

export const updateBackwardsNews = (id, body) => Api.patch(
  `${getBffUrl()}/backwards_news/${id}`,
  body
)

export const createNews = body => Api.post(
  `${getBffUrl()}/news`,
  body
)

export const deleteNews = newsIds => Api.destroy(
  `${getBffUrl()}/news/delete?ids=${newsIds}`
)

export const deleteBackwardsNews = newsIds => Api.destroy(
  `${getBffUrl()}/backwards_news/delete?ids=${newsIds}`
)

export const copyBackwardsNewsToNewsboard = newsIds => Api.post(
  `${getBffUrl()}/backwards_news/publish`,
  { news_ids: newsIds }
)

export const fetchInfluencer = id => Api.get(
  `${getBffUrl()}/influencers/${id}`
)

export const addInfluencerToContacts = (id, body) => Api.post(
  `${getBffUrl()}/influencers/${id}/add_to_contacts`,
  body
)
export const updateMailingList = (id, body) => Api.patch(
  `${getBffUrl()}/mailing_lists/${id}`,
  body
)

export const deleteMailingList = id => Api.destroy(
  `${getBffUrl()}/mailing_lists/${id}`
)

export const createMailingList = body => Api.post(
  `${getBffUrl()}/mailing_lists`,
  body
)

export const createSavedSearch = body => Api.post(
  `${getBffUrl()}/saved_searches`,
  body
)

export const searchSavedSearches = body => Api.post(
  `${getBffUrl()}/saved_searches/search`,
  body
)

export const updateSavedSearch = (id, body) => Api.patch(
  `${getBffUrl()}/saved_searches/${id}`,
  body
)

export const deleteSavedSearch = id => Api.destroy(
  `${getBffUrl()}/saved_searches/${id}`
)

export const createSavedSearchGroup = body => Api.post(
  `${getBffUrl()}/saved_search_groups`,
  body
)

export const updateSavedSearchGroup = (id, body) => Api.patch(
  `${getBffUrl()}/saved_search_groups/${id}`,
  body
)

export const deleteSavedSearchGroup = id => Api.destroy(
  `${getBffUrl()}/saved_search_groups/${id}`
)

export const assignSavedSearchToGroup = (groupId, savedSearchId) => Api.post(
  `${getBffUrl()}/saved_search_groups/${groupId}/saved_searches/${savedSearchId}`
)

export const removeSavedSearchFromGroup = (groupId, savedSearchId) => Api.destroy(
  `${getBffUrl()}/saved_search_groups/${groupId}/saved_searches/${savedSearchId}`
)

export const resolveSavedSearch = (id, body) => Api.post(
  `${getBffUrl()}/saved_searches/${id}/resolve`,
  body
)

export const fetchSavedSearchNewsFeed = (id, body) => Api.post(
  `${getBffUrl()}/saved_searches/${id}/news_feed`,
  body
)

export const fetchSavedSearchNewsFeedAiAnalysis = (id, body) => Api.post(
  `${getBffUrl()}/saved_searches/${id}/news_feed/ai_analysis`,
  body
)

export const createSavedSearchFeed = body => Api.post(
  `${getBffUrl()}/saved_searches/feeds`,
  body
)

export const updateSavedSearchFeed = (id, body) => Api.patch(
  `${getBffUrl()}/saved_searches/feeds/${id}`,
  body
)

export const deleteSavedSearchFeed = id => Api.destroy(
  `${getBffUrl()}/saved_searches/feeds/${id}`
)

export const fetchDashboardConfig = id => Api.get(
  `${getBffUrl()}/dashboards/${id}/config`
)

export const updateDashboard = (id, body) => Api.patch(
  `${getBffUrl()}/dashboards/${id}`,
  body
)

export const createDashboard = body => Api.post(
  `${getBffUrl()}/dashboards`,
  body
)

export const deleteDashboard = (id, userConfigId) => {
  let destroyRoute = `${getBffUrl()}/dashboards/${id}`

  if (userConfigId) {
    destroyRoute = `${destroyRoute}?user_config_id=${userConfigId}`
  }

  return Api.destroy(destroyRoute)
}

export const fetchSavedDashboard = urlName => Api.get(
  `${getBffUrl()}/saved_dashboards/by_url_name?url_name=${urlName}`
)

export const fetchSavedDashboardInfo = id => Api.get(
  `${getBffUrl()}/saved_dashboards/${id}`
)

export const deleteSavedDashboard = id => Api.destroy(
  `${getBffUrl()}/saved_dashboards/${id}`
)

export const createSavedDashboard = body => Api.post(
  `${getBffUrl()}/saved_dashboards`,
  body
)

export const checkSavedDashboardUrlName = body => Api.post(
  `${getBffUrl()}/saved_dashboards/check_url_name`,
  body
)

export const validateSpf = body => Api.post(
  `${getBffUrl()}/validation/spf`,
  body
)

export const authenticateGoogleAnalytics = body => Api.post(
  `${getBffUrl()}/auth/external/google_analytics`,
  body
)

export const revokeGoogleAnalytics = body => Api.post(
  `${getBffUrl()}/auth/external/google_analytics/revoke`,
  body
)

export const authenticateYoutubeAnalytics = body => Api.post(
  `${getBffUrl()}/auth/external/youtube_analytics`,
  body
)

export const revokeYoutubeAnalytics = body => Api.post(
  `${getBffUrl()}/auth/external/youtube_analytics/revoke`,
  body
)

export const authenticateLinkedIn = body => Api.post(
  `${getBffUrl()}/auth/external/linked_in`,
  body
)

export const revokeLinkedIn = body => Api.post(
  `${getBffUrl()}/auth/external/linked_in/revoke`,
  body
)

export const revokeFacebook = body => Api.post(
  `${getBffUrl()}/auth/external/facebook_analytics/revoke`,
  body
)

export const revokeTwitter = body => Api.post(
  `${getBffUrl()}/auth/external/twitter_analytics/revoke`,
  body
)

export const authenticateFacebook = body => Api.post(
  `${getBffUrl()}/auth/external/facebook_analytics`,
  body
)

export const fetchChartData = body => Api.post(
  `${getBffUrl()}/charts/data`,
  body
)

export const addIdentityToIdentitySet = (id, identityId) => Api.post(
  `${getBffUrl()}/identity_sets/${id}/identities/${identityId}`
)

export const removeIdentityFromIdentitySet = (id, identityId) => Api.destroy(
  `${getBffUrl()}/identity_sets/${id}/identities/${identityId}`
)

export const createIdentitySet = body => Api.post(
  `${getBffUrl()}/identity_sets`,
  body
)

export const updateIdentitySet = (id, body) => Api.patch(
  `${getBffUrl()}/identity_sets/${id}`,
  body
)

export const deleteIdentitySet = id => Api.destroy(
  `${getBffUrl()}/identity_sets/${id}`
)

export const getDarknetScoreResults = (ids, dateFrom, dateTo) => Api.get(
  `${getBffUrl()}/darknet/scores/results?ids=${ids}&dateFrom=${dateFrom}&dateTo=${dateTo}`
)

export const getDarknetDemoScoreResults = () => Api.get(
  `${getBffUrl()}/plotlights/demo/chart`
)

export const searchDarknetEntries = body => Api.post(
  `${getBffUrl()}/darknet/search/`,
  body
)

export const createDarknetSearchQuery = body => Api.post(
  `${getBffUrl()}/darknet/search/create`,
  body
)

export const updateDarknetSearchQuery = (id, body) => Api.patch(
  `${getBffUrl()}/darknet/search/update/${id}`,
  body
)

export const deleteDarknetSearchQuery = id => Api.patch(
  `${getBffUrl()}/darknet/search/delete/${id}`
)

export const createDarknetScoreQuery = body => Api.post(
  `${getBffUrl()}/darknet/scores/create`,
  body
)

export const updateDarknetScoreQuery = (id, body) => Api.patch(
  `${getBffUrl()}/darknet/score_queries/${id}`,
  body
)

export const deleteDarknetScoreQuery = id => Api.destroy(
  `${getBffUrl()}/darknet/score_queries/${id}`
)

export const fetchAllDarknetQueries = () => Api.get(
  `${getBffUrl()}/darknet/queries`
)

export const deactivateDarknetQuery = (id, body) => Api.post(
  `${getBffUrl()}/darknet/queries/${id}/deactivate`,
  body
)

export const activateDarknetQuery = (id, body) => Api.post(
  `${getBffUrl()}/darknet/queries/${id}/activate`,
  body
)

export const testSearchQuery = body => Api.post(
  `${getBffUrl()}/darknet/queries/test_search`,
  body
)

export const translate = body => Api.post(
  `${getBffUrl()}/translate`,
  body
)

export const buildExternalWidgetUrl = content => {
  const queryParams = new URLSearchParams({
    widget_content: content
  })

  return `${getBffUrl()}/charts/render_widget?${queryParams.toString()}`
}

export const sso = body => Api.post(
  `${getBffUrl()}/sso`,
  body
)

export const logSso = body => Api.post(
  `${getBffUrl()}/sso/log`,
  body
)

export const fetchSavedChart = (id, timezone, locale) => Api.get(
  `${getBffUrl()}/saved_charts/${id}/data?timezone=${encodeURIComponent(timezone)}&locale=${locale}`
)

export const createSavedChart = body => Api.post(
  `${getBffUrl()}/saved_charts`,
  body
)

export const deleteSavedChart = id => Api.destroy(
  `${getBffUrl()}/saved_charts/${id}`
)

export const updateSavedChart = (id, body) => Api.patch(
  `${getBffUrl()}/saved_charts/${id}`,
  body
)

export const submitApiKey = body => Api.post(
  `${getBffUrl()}/api_keys/`, body
)

export const deleteApiKey = id => Api.destroy(
  `${getBffUrl()}/api_keys/${id}`
)

export const extractTextFromPdf = file => {
  const formData = new FormData()
  formData.append('file', file)

  return Api.form(
    `${getBffUrl()}/extract`,
    formData
  )
}

export const markNotificationAsRead = body => Api.post(
  `${getBffUrl()}/notifications/mark_as_read`, body
)

export const fetchNotifications = (page, limit, sortBy, sortOrder) => Api.get(
  `${getBffUrl()}/notifications?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_order=${sortOrder}`
)

export const submitSurvey = () => Api.post(`${getBffUrl()}/submit_survey`)

export const searchUnsplashPhotos = body => Api.post(
  `${getBffUrl()}/unsplash/photos/search`, body
)

export const fetchRandomUnsplashPhotos = body => Api.post(
  `${getBffUrl()}/unsplash/photos/random`, body
)

export const downloadUnsplashImage = body => Api.post(
  `${getBffUrl()}/unsplash/photos/download`, body
)

export const fetchOpenGraphMetadata = body => Api.post(
  `${getBffUrl()}/open_graph/metadata`, body
)

export const uploadFileFromUrl = body => Api.post(
  `${getBffUrl()}/upload_from_url`, body
)

export const searchThemaxEditorialPlans = body => Api.post(
  `${getBffUrl()}/themax/search/editorial_plans`, body
)

export const searchThemaxPublications = body => Api.post(
  `${getBffUrl()}/themax/search/publications`, body
)

export const exportThemaxEditorialPlans = body => Api.post(
  `${getBffUrl()}/themax/export/excel/editorial_plans`,
  body,
  'blob'
)

export const searchThemaxSavedSearches = body => Api.post(
  `${getBffUrl()}/themax/saved_searches/search`,
  body
)

export const fetchThemaxSavedSearch = id => Api.get(
  `${getBffUrl()}/themax/saved_searches/${id}`
)

export const createThemaxSavedSearch = body => Api.post(
  `${getBffUrl()}/themax/saved_searches`,
  body
)

export const updateThemaxSavedSearch = (id, body) => Api.patch(
  `${getBffUrl()}/themax/saved_searches/${id}`,
  body
)

export const deleteThemaxSavedSearch = id => Api.destroy(
  `${getBffUrl()}/themax/saved_searches/${id}`
)

export const favoriteThemaxSavedSearch = id => Api.post(
  `${getBffUrl()}/themax/saved_searches/${id}/favorite`
)

export const createOrder = body => Api.post(
  `${getBffUrl()}/orders`,
  body
)

export const createGrootEditorialPlan = body => Api.post(
  `${getBffUrl()}/themax/groot_editorial_plans`,
  body
)

export const deleteGrootEditorialPlan = id => Api.destroy(
  `${getBffUrl()}/themax/groot_editorial_plans/${id}`
)

export const clickTrace = body => Api.post(
  `${getBffUrl()}/click_trace`,
  body
)

export const processTraceData = body => Api.post(
  `${getBffUrl()}/process_trace_data`,
  body
)

export const fetchWhitelabelConfig = () => Api.get(
  `${getBffUrl()}/whitelabel/config`
)
